export default {
  form: {
    country: {
      label: 'Land',
      placeholder: 'Vælg land',
    },
  },
};
